import {
  Activity,
  ClipboardList,
  Droplet,
  Droplets,
  FlaskConical,
  Footprints,
  HandHeart,
  HeartPulse,
  Pill,
  ScanLine,
  Scissors,
  Stethoscope,
  UtensilsCrossed,
  Wind,
  type LucideIcon,
} from 'lucide-react';
import type { IpdOrderKind } from '@his/shared';

const ICONS: Readonly<Record<IpdOrderKind, LucideIcon>> = {
  medication: Pill,
  iv_fluid: Droplets,
  diet: UtensilsCrossed,
  nursing: HandHeart,
  procedure: Scissors,
  lab: FlaskConical,
  radiology: ScanLine,
  blood_transfusion: Droplet,
  oxygen: Wind,
  physiotherapy: Footprints,
  consult: Stethoscope,
  vitals_monitoring: HeartPulse,
};

export function orderKindIcon(kind: string): LucideIcon {
  return ICONS[kind as IpdOrderKind] ?? (kind ? Activity : ClipboardList);
}
